// The support-chat feature's public client surface (RFC rule 8). Named
// re-exports only — exactly what other features already imported.
export {
  SupportDrawerProvider,
  useSupportDrawer,
} from "@/src/features/support-chat/SupportDrawerProvider";
